import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('pricing', [
      'monthlyPrice',
      'formattedMonthlyPrice',
      'formattedAnnualPrice',
    ]),
  },
  methods: {
    getMonthlyPrice() {
      return this.formattedMonthlyPrice;
    },
    getAnnualPrice() {
      return this.formattedAnnualPrice;
    },
    getMonthlyPriceNumber() {
      return this.monthlyPrice;
    },
  },
};
